var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#175AFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.516 15.644C10.028 15.644 9.564 15.556 9.124 15.38C8.692 15.196 8.32 14.94 8.008 14.612C7.704 14.276 7.496 13.88 7.384 13.424L8.812 12.92C8.956 13.328 9.176 13.64 9.472 13.856C9.768 14.064 10.116 14.168 10.516 14.168C10.836 14.168 11.112 14.108 11.344 13.988C11.584 13.868 11.772 13.696 11.908 13.472C12.044 13.24 12.112 12.968 12.112 12.656C12.112 12.344 12.044 12.08 11.908 11.864C11.78 11.64 11.596 11.468 11.356 11.348C11.116 11.228 10.832 11.168 10.504 11.168C10.352 11.168 10.192 11.184 10.024 11.216C9.864 11.248 9.72 11.296 9.592 11.36L9.22 10.58L11.536 7.94H7.888V6.56H13.372V7.844L11.044 10.568L11.068 9.956C11.604 9.964 12.072 10.08 12.472 10.304C12.872 10.528 13.184 10.836 13.408 11.228C13.632 11.62 13.744 12.08 13.744 12.608C13.744 13.184 13.604 13.704 13.324 14.168C13.044 14.624 12.66 14.984 12.172 15.248C11.684 15.512 11.132 15.644 10.516 15.644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3);
export default __webpack_public_path__ + "static/media/number3.59a77e2e96c536f3248c9fdf40d2d46b.svg";
export { ForwardRef as ReactComponent };